/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateSubmissionsPathParams, CandidateSubmissionsResponse } from '../types/CandidateSubmissions'

/**
 * GET /candidates/:candidate/submissions
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateController.php CandidateController::submissions
 */
export async function candidateSubmissions(
	candidate: CandidateSubmissionsPathParams['candidate'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateSubmissionsResponse>> {
	return axiosInstance.get(`/candidates/${candidate}/submissions`, config)
}
